module.exports = __webpack_public_path__ + "img/swiper1.f046b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/swiper1.png
// module id = 418
// module chunks = 0